import type { ErrorEvent } from '@sentry/react';
import isNil from 'lodash/isNil';

const MARKER_IO_SCRIPT_URL = /^https:\/\/([a-z0-9-]+\.)*marker\.io\//;
// The shim wraps window.fetch, so a failed app request carries a shim frame too.
const MARKER_IO_SHIM_URL = /\/shim\.js(\?|$)/;

const isMarkerIoWidgetFrame = (filename: string): boolean =>
  MARKER_IO_SCRIPT_URL.test(filename) && !MARKER_IO_SHIM_URL.test(filename);

/** True when the error went through the Marker.io widget code, which is not ours to fix. */
export const isMarkerIoWidgetError = (event: ErrorEvent): boolean =>
  (event.exception?.values ?? []).some((exception) =>
    (exception.stacktrace?.frames ?? []).some(
      (frame) => !isNil(frame.filename) && isMarkerIoWidgetFrame(frame.filename)
    )
  );
